import { LinearProgress, styled } from '@mui/material';
import { forwardRef } from 'react';

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => {
    return {
        borderRadius: '4px',
        width: '100%',
        height: '8px',
        background: theme.palette.ensightful.primary[50],
        '& .MuiLinearProgress-bar': {
            borderRadius: '4px',
        },
    };
});

export default forwardRef((props, ref) => {
    return <CustomLinearProgress ref={ref} variant={'determinate'} {...props} />;
});
